import { apiSlice } from './apiSlice';

export const authApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        login: builder.mutation({
            query: credentials => ({
                url: '/accounts/admin/login',
                method: 'POST',
                body: { ...credentials },
            }),
        }),
        forgotPassword: builder.mutation({
            query: email => ({
                url: '/accounts/forgotPassword',
                method: 'POST',
                body: { ...email },
            }),
        }),
        resetPassword: builder.mutation({
            query: newPassword => ({
                url: '/accounts/passwordReset',
                method: 'POST',
                body: { ...newPassword },
            }),
        })
    }),
});

export const { useLoginMutation, useForgotPasswordMutation, useResetPasswordMutation } = authApiSlice;
